import { render, staticRenderFns } from "./AddReportTabs.vue?vue&type=template&id=bc97648a&scoped=true&"
import script from "./AddReportTabs.vue?vue&type=script&lang=js&"
export * from "./AddReportTabs.vue?vue&type=script&lang=js&"
import style0 from "./AddReportTabs.vue?vue&type=style&index=0&id=bc97648a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc97648a",
  null
  
)

export default component.exports